import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierCancelFoodPage.setFetching(isFetching)

const fetch = ({ fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc 

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return (
    request.post(prefix.cashierRefund + `/${schoolId}`, {
      fromInt,
      toInt,
    })
      .then(({ data }) => data)
      .then((order) => {
        reducers.marketplace.cashierCancelFoodPage.setOrders(order)

        return order
      })
  )
}

const cancelPartial = (orderId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.cashierCancelPartial + `/${orderId}`, {})
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)

      return {}
    })
}


export default {
  setFetching,
  cancelPartial,
  fetch,
}
